import React, { Component } from 'react';
import globals from "../globals";
import HelmetDefault from "../layout/HelmetDefault";
import Hero from "../modules/Hero/Hero";
import SecondHeading from "../modules/SecondHeading";
import TickList from "../elements/TickList";
import RegisterInterestForm from "../forms/RegisterInterestForm/RegisterInterestForm";
import Heading from "../elements/Heading";
import ThreeColumnIcons from "../modules/ThreeColumnIcons/ThreeColumnIcons";

class WorkFromHome extends Component {

	constructor(props) {
        super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			seoTitle: '',
			seoDescription: '',
            secondHeading: {
			    content: []
            },
            secondHeading2: {},
            form: {},
            threeColumnIcons: {
			    items: []
            },
			dataReceived: false
		};
	}

	componentDidMount() {
		this.getData();
	}

	getData() {
		fetch('/api/voip/work-from-home')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	render() {
		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}}>
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <div className="second-heading-wrapper">
                    <div className="inner">
                        <SecondHeading data={this.state.secondHeading}>
                            <TickList list={this.state.secondHeading.content} />
                        </SecondHeading>
                    </div>
                    <div className="bottom-wave-darkgreen" />
                </div>
                <SecondHeading data={this.state.secondHeading2} className="second-heading-2" />
                <RegisterInterestForm
                    title={this.state.form.title}
                    subTitle={this.state.form.subTitle}
                    reverse={true}
                    submitEvent="banterWorkFromHomeFormSubmit"
                    hjEvent="/voip/banter-work-from-home/submit"
                    product="banter-wfh"
                />
                <ThreeColumnIcons data={this.state.threeColumnIcons} dataReceived={this.state.dataReceived} />
			</div>
		);
	}

}

export default WorkFromHome;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/WorkFromHome.js